import React from 'react'
import { graphql } from 'gatsby'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'

// core components
import Menu from 'components/Menu/Menu.jsx'
import Layout from 'components/layout'

import About from 'sections/about'
import Banner from 'sections/banner'
import Writings from 'sections/writings'
import Contributions from 'sections/contributions'
import Geek from 'sections/geek'
import Skills from 'sections/skills'
import withRoot from '../withRoot'

// building the library of icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { faGithub, faTwitter, faDev } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faCode, faRobot } from '@fortawesome/free-solid-svg-icons'

library.add(faGithub, faTwitter, faDev, faEnvelope, faCode, faRobot)

const indexStyle = {}

const ProfilePage = ({ data }) => {
  data = formatData(data)
  return (
    <Layout>
      <Menu brand="Adrien Poly" sections={data.sections} />
      <Banner />
      <About {...data.sectionsObject['about']} image={data.profileImage} />
      <Skills
        {...data.sectionsObject['skills']}
        items={data.skills}
        background="#dfe4ea"
      />
      <Writings {...data.sectionsObject['writings']} items={data.writings} />
      <Contributions
        {...data.sectionsObject['contributions']}
        items={data.contributions}
        background="#dfe4ea"
      />
      <Geek
        {...data.sectionsObject['geeks']}
        image={data.geekImage}
        items={data.geekList}
      />
    </Layout>
  )
}

const formatData = data => {
  const formatedData = {
    ...data,
    geekList: data.geekList.edges.map(item => item.node),
    writings: data.articles.edges.map(item => ({
      ...item.node,
      linkText: `👉 dev.to`,
    })),
    contributions: data.projects.edges.map(item => item.node.data),
    skills: data.skills.edges.map(domain => ({
      id: domain.node.id,
      title: domain.node.data.title,
      list: domain.node.data.list.map(skill => ({ ...skill.data })),
    })),
    sections: data.sections.edges.map(item => item.node.data),
    sectionsObject: data.sections.edges.reduce(
      (obj, item) => ({ ...obj, [item.node.data.name]: { ...item.node.data } }),
      {}
    ),
  }
  return formatedData
}

export default withRoot(withStyles(indexStyle)(ProfilePage))

export const fluidImage = graphql`
  fragment fluidImage on File {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
`

export const fixedIcon = graphql`
  fragment fixedIcon on File {
    childImageSharp {
      fixed(width: 160) {
        ...GatsbyImageSharpFixed
      }
    }
  }
`

export const pageQuery = graphql`
  query {
    profileImage: file(relativePath: { eq: "profilepic.jpg" }) {
      ...fixedIcon
    }
    geekImage: file(relativePath: { eq: "geek-icon.png" }) {
      ...fixedIcon
    }
    geekList: allGeekYaml {
      edges {
        node {
          title
          url
          text
          linkText
          icon
          id
        }
      }
    }
    articles: allRssEntry {
      edges {
        node {
          title
          url: link
        }
      }
    }
    projects: allAirtable(filter: { table: { eq: "projects" } }) {
      edges {
        node {
          data {
            url
            linkText
            text
            title
          }
        }
      }
    }
    skills: allAirtable(filter: { table: { eq: "skillTypes" } }) {
      edges {
        node {
          id
          data {
            name
            title
            list: skills {
              id
              data {
                title
                url
                linkText
                text
              }
            }
          }
        }
      }
    }
    sections: allAirtable(filter: { table: { eq: "sections" } }) {
      edges {
        node {
          data {
            name
            menuTitle
            title
            subtitle: text
          }
        }
      }
    }
  }
`
